import React, { useState } from 'react';
import { Carousel } from '../../Carousel';
import styles from './maingallery.module.sass';
import Sl from '../../OpenLigtBox/OpenLightBox';
import { GalleryModal } from '../../GalleryModal';
import { YaAndGaCruisePage, YaAndGaShipPage } from '../../../lib/YaAndGaHelper';
import { ReworkUrl } from '../../../utils/reworkUrl';
import { Image } from '../../Image/Image';

export const prepareImages = (maxi, mini, needCrop = false) => {
  if (needCrop)
    return mini.map(i => ({
      ...i,
      url: i.url,
    }));

  return maxi.map(i => ({
    ...i,
    url: i.url,
  }));
};

export const MainGallery = ({
  maxi,
  mini,
  isMobile,
  reviews,
  category,
  title,
  shipPage,
  isSea,
  onCloseAction,
  onActionClose,
  onPrevArrow,
  onNextArrow,
  onClickImg,
  onImgClick,
  onClickMore,
  onMoreClick,
  onArrowNext,
  onArrowPrev,
}) => {
  const [isGalleryOpen, setIsGalleryOpen] = useState(null);
  const maxiImages = prepareImages(maxi, mini, false);
  const miniImages = prepareImages(maxi, mini, true);
  const openGallery = (e, index) => {
    e.preventDefault();
    setIsGalleryOpen(index);
  };

  // const getUrl = (url, _isSea) => _isSea ? `sea.${process.env.NEXT_PUBLIC_BASE_URL.}${url}` : `${process.env.NEXT_PUBLIC_BASE_URL}${url}`;
  // sea.https://kruiz.tech/assets/img/liners/liners/bergth_800x500/165933246662e76772b0aa9.jpg
  return isMobile ? (
    <Carousel data={maxiImages} />
  ) : (
    <>
      <GalleryModal
        isMobile={isMobile}
        title={title}
        category={category}
        maxi={maxiImages}
        mini={miniImages}
        reviews={reviews}
        activeImg={isGalleryOpen}
        onClose={setIsGalleryOpen}
        onCloseAction={onCloseAction}
        onActionClose={onActionClose}
        onPrevArrow={onPrevArrow}
        onNextArrow={onNextArrow}
        onClickImg={onClickImg}
        onImgClick={onImgClick}
        onClickMore={onClickMore}
        onMoreClick={onMoreClick}
        onArrowNext={onArrowNext}
        onArrowPrev={onArrowPrev}
      />
      <div className={!shipPage ? styles.imagesBlock : styles.imagesBlockShip}>
        <a
          href={ReworkUrl(maxiImages[0].url)}
          onClick={e => {
            openGallery(e, 0);
            if (!shipPage && !isSea) {
              YaAndGaCruisePage('click_modal_photo');
            }
            if (shipPage && !isSea) {
              YaAndGaShipPage('click_view_all_photos');
            }
          }}
        >
          <Image
            className={styles.headerImage}
            src={maxiImages[0].url.src}
            srcSet={maxiImages[0].url.srcset}
            alt={maxiImages[0].description}
            loading={'lazy'}
            title={maxiImages[0].description}
          />
          <Sl onClick={e => openGallery(e, 0)} />
        </a>
        {!shipPage && (
          <div className={styles.gridImages}>
            {maxiImages.slice(1, 5).map((i, index) => (
              <a
                key={i.url}
                href={ReworkUrl(i.url)}
                onClick={e => openGallery(e, index + 1)}
              >
                <Image
                  className={styles.gridImage}
                  src={i.url.src}
                  srcSet={i.url.srcset}
                  alt={i.description}
                  key={i.url}
                  title={i.description}
                  loading={'lazy'}
                />
              </a>
            ))}
          </div>
        )}

        {shipPage && (
          <div className={styles.gridImagesShips}>
            {maxiImages.slice(1, 4).map((i, index) => (
              <a
                key={i.url}
                href={ReworkUrl(i.url)}
                onClick={e => openGallery(e, index + 1)}
              >
                <Image
                  className={styles.gridImage}
                  src={i.url.src}
                  srcSet={i.url.srcset}
                  alt={i.description}
                  key={i.url}
                  title={i.description}
                  loading={'lazy'}
                />
              </a>
            ))}
          </div>
        )}
      </div>
    </>
  );
};
